import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import { BasicService } from './basic_service';
import { HelperService } from './helper_service';
import { Router } from '@angular/router';

@Injectable()
export class CommonService {
  token: string;
  isPickupIdCheck: boolean = true;
  isAlreadyOpen: boolean = false;
  isManualendOpen: boolean = false;
  publicFilterDate: number = null;
  publicFilterTime: number = null;
  constructor(
    private http: HttpClient,
    public basicService: BasicService,
    public helperService: HelperService,
    private route: Router,
  ) {
    this.getToken();
  }
  public getToken(): string {
    return localStorage.getItem('token');
  }
  get<T>(url: string, params?: string): Observable<T> {
    const token = this.getToken();
    let headers = new HttpHeaders()
      .set("Accept", 'application/json')
      .set('Content-Type', 'application/json')
      .set('Authorization', 'Bearer ' + token);
    return this.http.get<T>(this.basicService.url + url, { headers: headers })
      .map((res) => {
        if (res)
        return res;
      });
  };
 
  post<T>(url: string, data): Observable<T> {
    const token = this.getToken();
    let headers = new HttpHeaders()
      .set("Accept", 'application/json')
      .set('Content-Type', 'application/json')
      .set('Authorization', 'Bearer ' + token);
    return this.http.post<T>(this.basicService.url + url, data, { headers: headers })
      .map((res) => {
        if (res)
          // this.checkAuth(res);
        return res;
      });
  }

  patch<T>(url: string, data): Observable<T> {
    const token = this.getToken();
    let headers = new HttpHeaders()
      .set("Accept", 'application/json')
      .set('Content-Type', 'application/json')
      .set('Authorization', 'Bearer ' + token);
    return this.http.patch<T>(this.basicService.url + url, data, { headers: headers })
      .map((res) => {
        if (res)
          // this.checkAuth(res);
        return res;
      });
  }

  // post<T>(url: string, data): Observable<T> {
  //   const token = this.getToken();
  //   let headers = new HttpHeaders()
  //     .set("Accept", 'application/json')
  //     .set('Content-Type', 'application/json')
  //     .set('Authorization', 'Bearer ' + token);
  //   return this.http.post<T>(this.basicService.LiveURL + url, data, { headers: headers })
  //     .map((res) => {
  //       if (res)
  //         // this.checkAuth(res);
  //       return res;
  //     });
  // }
  // postWithFormData<T>(url, data): Observable<T> {
  //   const token = this.getToken();
  //   let headers = new HttpHeaders()
  //     .set("Accept", 'application/json')
  //     .set('Content-Type', 'application/json')
  //     // .set('Content-Type', 'application/x-www-form-urlencoded')
  //     .set('Authorization', 'Bearer ' + token);
  //   return this.http.post<T>(this.basicService.LiveURL + url, data, { headers: headers })
  //     .map((res) => {
  //       if (res)
  //         // this.checkAuth(res);
  //       return res;
  //     });
  // }
  checkAuth(res) {
    if (!res?.error?.success) {
      localStorage.clear();
      this.route.navigate(['/signup']);
    }
  }
}
